import { alpha } from '@mui/material/styles';
import styled from '@emotion/styled';
import { Button } from '@mui/material';
import { Row } from '../../../styles';
import { shouldForwardProps } from '../../../utils';

const FabWrapper = styled(Button, shouldForwardProps)<{ isExpanded: boolean }>`
    display: flex;
    min-width: 56px;
    height: 56px;
    border-radius: 16px;
    justify-content: ${({ isExpanded }) => (isExpanded ? 'flex-start' : 'center')};
    align-self: ${({ isExpanded }) => (isExpanded ? 'start' : 'center')};
    width: ${({ isExpanded }) => (isExpanded ? '235px' : '56px')};
    margin-left: ${({ theme }) => theme.spacing(2)};
    margin-right: ${({ theme }) => theme.spacing(2)};
    padding: 0;
    margin-bottom: 38px;
    background-color: ${({ theme }) => theme.colors.tertiary};
    color: ${({ theme }) => theme.colors.onTertiary};
    &:hover {
        background-color: ${({ theme }) =>
            alpha(theme.colors.tertiary, 1 - (theme.palette.action?.hoverOpacity ?? 0))};
    }
`;

const FabContent = styled(Row)`
    padding: ${({ theme }) => theme.spacing(2)};
    gap: ${({ theme }) => theme.spacing(1.5)};
`;

export { FabWrapper, FabContent };
